import { createContext } from 'react'

/*
 * CouponMarketplaceContext
 * Create Alert context for custom hook
 */
const CouponMarketplaceContext = createContext({
  coupon: {},
  coupons: [],
  couponToken: {},
  couponTokens: [],
  detailType: 'coupon',
  hasMoreCoupons: false,
  hasMoreCouponTokens: false,
  isCouponDetailOpen: false,
  isCouponMarketplaceOpen: false,
  isCouponsReady: false,
  isCouponRedeemed: false,
  isCouponTokenDetailOpen: false,
  isCouponTokensReady: false,
  isDetailOpen: false,
  isDetailReady: false,
  isLoading: false,
  isModalOpen: false,
  isPopupOpen: false,
  modalContent: {},
  popupMessage: {},
  userCurrentPoints: 0,
  onApplyCoupon: () => {},
  onApplyCouponError: () => {},
  onApplyCouponSuccess: () => {},
  onCouponDetailClose: () => {},
  onCouponDetailOpen: () => {},
  onCouponMarketplaceClose: () => {},
  onCouponMarketplaceOpen: () => {},
  onFetchCoupons: () => {},
  onFetchCouponsNextPage: () => {},
  onFetchCouponTokens: () => {},
  onFetchCouponTokensNextPage: () => {},
  onModalClose: () => {},
  onModalOpen: () => {},
  onPopupClose: () => {},
  onPopupOpen: () => {},
  onRedeemCoupon: () => {},
  onRedeemCouponConfirm: () => {},
  onRedeemCouponError: () => {},
  onRedeemCouponSuccess: () => {},
})

export default CouponMarketplaceContext
